import { CommonModule } from "@angular/common";
import { Component, forwardRef, Input, OnDestroy, OnInit } from "@angular/core";
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { LabelMode } from "src/utils/label-mode.enum";
import { GenerateRandom } from "src/utils/random";

@Component({
  selector: "app-radio",
  templateUrl: "./radio.component.html",
  styleUrls: ["./radio.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioComponent),
      multi: true,
    },
  ],
  imports: [CommonModule, ReactiveFormsModule, TranslateModule],
})
export class RadioComponent implements OnInit, ControlValueAccessor, OnDestroy {
  @Input() name = GenerateRandom(6);
  @Input() label: string;
  @Input() labelValue = "";
  @Input() placeholder = "";
  @Input() options: any = [];
  @Input() inputClass: string;
  @Input() labelStyle = "fw-bold fs-6";
  @Input() classes: string;
  @Input() required = false;

  LabelMode = LabelMode;
  mode: LabelMode = LabelMode.DEFAULT;

  form = new FormControl();
  subscription: Subscription;

  constructor() {}

  @Input()
  set isDisabled(value: boolean) {
    if (value) {
      this.form.disable();
    } else {
      this.form.enable();
    }
  }

  @Input() set value(value: any) {
    this.form.setValue(value);
  }

  @Input() set labelMode(value: LabelMode) {
    this.mode = value;
  }

  onChange = (value: string) => {};
  onTouched = (value: string) => {};

  ngOnInit(): void {
    this.subscription = this.form.valueChanges.subscribe((value) => {
      this.onChange(value);
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  writeValue(obj: any): void {
    this.form.setValue(obj);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {}
}
